$(document).ready(function(){

  if ($("#homepage").length){


  }

});
